module.exports = __webpack_public_path__ + "img/Pista_0321.2e59042c.png";